import React, { useState } from 'react';
import { Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { GeneralModalProps } from '../assets/interfaces/interfaces';
import { showNotification } from "../redux/slices/notificationSlice";
import { useDispatch } from 'react-redux';

const ContactSupportModal: React.FC<GeneralModalProps> = ({ open, handleClose }) => {
    const dispatch = useDispatch();
    const [name, setName] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const isFormValid = name.length && subject.length && message.length;

    const onSubmit = (event: any) => {
        event.preventDefault()
        try {
        const sub = encodeURIComponent(subject + ' - ' + name);
        const body = encodeURIComponent(message);
        const mailto = `mailto:support@tradealgo.com?subject=${sub}&body=${body}`;
        window.location.href = mailto;
        // dispatch(showNotification({ message: 'Form submitted successfully', severity: 'success', horizontal: 'center' }));
        setName('');
        setSubject('');
        setMessage('');
        } catch (error) {
            dispatch(showNotification ({message: 'Form submission failed', severity: 'error', horizontal: 'center'}))
        }
    }

    return (
        <Modal open={open} onClose={handleClose}>
            <div className="fixed inset-0 flex items-center justify-center p-4">
                <div className="bg-white rounded-lg shadow-lg w-full max-w-md">
                    <div className="flex justify-between items-center bg-gray-100 p-4 rounded-t-lg border-b-2 border-gray-200">
                        <h2 className="text-xl font-semibold">Contact Support</h2>
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <div className="bg-white p-6">
                        <div className='text-3xl font-bold pb-2'>
                            Got Questions?
                        </div>
                        <p className="text-sm text-gray-600">
                            Let us know what problem you are facing. If you have general questions about TradeGPT, check out our <a href="/faq" className="text-blue-600 hover:text-blue-800 underline">FAQ & Help Center</a> where you might find the answer you're after even quicker.
                        </p>
                        <form onSubmit={onSubmit} autoComplete="off">
                            <div className="mt-4">
                                <label htmlFor="name" className="block text-sm font-medium text-gray-700">Your Name</label>
                                <input
                                    type="text"
                                    id="name"
                                    className="mt-1 border w-full rounded-md border-gray-300 shadow-sm h-10 pl-2 input-focus "
                                    placeholder="Enter full name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                            <div className="mt-4">
                                <label htmlFor="subject" className="block text-sm font-medium text-gray-700">Subject</label>
                                <input
                                    id="subject"
                                    className="mt-1 border w-full rounded-md border-gray-300 shadow-sm h-10 pl-2 input-focus"
                                    placeholder="Email subject"
                                    value={subject}
                                    onChange={(e) => setSubject(e.target.value)}
                                />
                            </div>
                            <div className="mt-4">
                                <label htmlFor="message" className="block text-sm font-medium text-gray-700">Message</label>
                                <textarea
                                    id="message"
                                    className="mt-1 border w-full rounded-md border-gray-300 shadow-sm pl-2 pt-2 textarea-focus"
                                    rows={4}
                                    placeholder="Enter your message"
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                >
                                </textarea>
                            </div>
                            <div className="mt-6">
                                <button
                                    type="submit"
                                    className={`w-2/3 flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-black ${!isFormValid ? '!opacity-50' : ""}`}
                                    disabled={!isFormValid}
                                >
                                    Send Support Request
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ContactSupportModal;
